<template>
  <div class="bg">
    <div class="wrapper">
      <p v-if="tasks.length<=0 && showLoading===false" class="center">暂无待办事项</p>
      <TaskItem
        v-for="item in tasks"
        v-else
        :key="item.taskId"
        :ref="`${item.taskId}`"
        :item="item"
        @delete="deleteTask(item.taskId)"
        @swipeleft="swipeleft($event)"
        @click="clickHandler(item.taskId)"/>
      <router-link class="btn-new" to="/task-form"></router-link>
    </div>
  </div>
</template>

<script>
  import {mapActions,mapGetters} from 'vuex';
  import TaskItem from '../../components/TaskItem';


  export default {
    name: "Tasks",
    components: {
      TaskItem,
    },
    computed: {
      ...mapGetters(['tasks','showLoading']),
    },
    methods: {
      ...mapActions(['getTasks','deleteTask']),
      swipeleft($event) {
        for (let key in this.$refs) {
          if (key === $event) {
            this.$refs[key][0].showDelete();
          } else {
            if(this.$refs[key].length===1){
              //必须为1 要不然会报错
              this.$refs[key][0].hideDelete();
            }
          }
        }
      },
      clickHandler(taskId) {
        this.$router.push({
          name: 'task-detail',
          params: {taskId: taskId}
        })
      }
    },
    created() {
      window.document.title = '待办事项';
      this.getTasks();
    },
  }
</script>

<style scoped>
  .btn-new {
    width: 46px;
    height: 46px;
    background: rgba(53, 121, 255, 1);
    box-shadow: 0px 3px 6px rgba(53, 121, 255, 0.27);
    border-radius: 50%;
    display: block;
    position: fixed;
    right: 25px;
    bottom: 61px;
    z-index: 9;
  }

  .btn-new::before {
    content: '';
    width: 2px;
    height: 22px;
    background: #fff;
    border-radius: 10px;
    top: 12px;
    left: 22px;
    position: absolute;
  }

  .btn-new::after {
    content: '';
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 10px;
    top: 22px;
    left: 12px;
    position: absolute;
  }
</style>